import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import DataTable from '../DataTable';
import ConfirmDeleteModal from '../ConfirmDeleteModal';
import SearchSpecificLink from './SearchSpecificLink';
import SpecificLinkCategoriesTable from './SpecificLinkCategoriesTable';
import CreateSpecificLinkCategoryModal from './CreateSpecificLinkCategoryModal';

const SpecificLinkCategoriesMain = ({ render, setRender, data, rows, setPassSelectedCategoryId, columns, onAssignToPBS }) => {
    const [rowsData, setRowsData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('all');
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [delCategoryId, setDelCategoryId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [delData, setDeleteData] = useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});


    useEffect(() => {
        setRowsData(rows);
        fetchCategories();
        loadColumnVisibility();
    }, [render]);

    useEffect(() => {
        handleCategorySelect(selectedCategoryId);
    }, [render]);

    const handleBulkDelete = async (deleteData) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}specific-link/bulk-delete`, { linkIds: deleteData } ,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success(response.data.message || 'Selected PBS deleted successfully');
            setRender(prev => !prev);
        } catch (error) {
            toast.error(error.response.data.message || 'Failed to delete selected PBS');
        }
    };

    const handleDeleteCategory = async (categoryId) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}specific-link-category/delete/${categoryId}`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success(response.data.message || 'Category deleted successfully');
            setRender(prev => !prev);
        } catch (error) {
            toast.error('Failed to delete category');
        }
    };

    const ConfirmHandleDelete = (deleteData) => {
        setIsDeleteModalOpen(true);
        setDeleteData(deleteData);
    };

    const handleDeleteConfirm = () => {
        setIsDeleteModalOpen(false);
        handleBulkDelete(delData);
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}specific-link-category/all`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setCategories(response.data);
        } catch (error) {
            toast.error('Failed to fetch categories');
        }
    };

    const fetchPBSByCategory = async (categoryId, page = 1, limit = 100) => {
        try {
            const url = `${process.env.REACT_APP_BASE_URL}specific-link-category/${categoryId}/links?page=${page}&limit=${limit}`;
            const response = await axios.get(url,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setTotalPages(response.data.totalPages);
            setCurrentPage(response.data.currentPage);
            setTotalItems(response.data.totalItems);
            const flattenPBS = response?.data?.links.map((row) => ({
                id: row._id,
                _id: row._id,
                url: row.url,
                keyword: row.keyword,
                timeInitiated: row.timeInitiated,
                limitToday: row.limitToday,
                countToday: row.countToday,
                   
            }));

            setRowsData(flattenPBS);
        } catch (error) {
            toast.error('Failed to fetch questions by category');
        }
    };

    const setSearchSpecificLink = (pbsData) => {
        setTotalPages(pbsData.totalPages);
        setCurrentPage(pbsData.currentPage);
        setTotalItems(pbsData.totalItems);
        const flattenPBS = pbsData.links.map((row) => ({
            id: row._id,
            _id: row._id,
            url: row.url,
            keyword: row.keyword,
            timeInitiated: row.timeInitiated,
            limitToday: row.limitToday,
            countToday: row.countToday,
    
        }));
        console.log(flattenPBS , "flattenPBS");
        setRowsData(flattenPBS);

    }
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchPBSByCategory(selectedCategoryId, newPage);
    };

    const handleCategorySelect = (categoryId) => {
        setCurrentPage(1);
        setSelectedCategoryId(categoryId);
        setPassSelectedCategoryId(categoryId);
        fetchPBSByCategory(categoryId, 1);
    };

    const loadColumnVisibility = () => {
        const storedVisibility = localStorage.getItem('specificLinkColumnVisibility');
        if (storedVisibility) {
            setColumnVisibilityModel(JSON.parse(storedVisibility));
        }
    };

    const saveColumnVisibility = (model) => {
        localStorage.setItem('specificLinkColumnVisibility', JSON.stringify(model));
        setColumnVisibilityModel(model);
    };

    return (
        <div>
            <SearchSpecificLink setSearchSpecificLink={setSearchSpecificLink} />
            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                <div style={{ flex: 2, marginRight: "20px" }}>
                    <SpecificLinkCategoriesTable onCategorySelect={handleCategorySelect} categories={categories} handleDeleteCategory={handleDeleteCategory} />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            style={{ width: "130px", height: "50px", padding: "10px", marginTop: "15px", backgroundColor: '#1B3C73', color: "white" }}
                            variant="outlined"
                            size="small"
                            onClick={() => setIsCreateModalOpen(true)}
                        >
                            Category
                        </Button>
                    </div>
                </div>
                <div style={{ flex: 10 }}>
                    {data.length > 0 && rowsData.length > 0 ? (
                        <DataTable rows={rowsData} columns={columns} onDeleteSelected={ConfirmHandleDelete} onAssignToPBS={onAssignToPBS} handlePageChange={handlePageChange} currentPage={currentPage} totalPages={totalPages} totalItems={totalItems} saveColumnVisibility={saveColumnVisibility} columnVisibilityModel={columnVisibilityModel} />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <CreateSpecificLinkCategoryModal
                open={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                fetchCategories={fetchCategories}
            />
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <ConfirmDeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleDeleteConfirm}
                message="Are you sure you want to delete this Specific Link?"
            />
        </div>
    );
};

export default SpecificLinkCategoriesMain;

